import { render } from "./NewIncident.vue?vue&type=template&id=8a3986dc&scoped=true"
import script from "./NewIncident.vue?vue&type=script&lang=js"
export * from "./NewIncident.vue?vue&type=script&lang=js"

import "./NewIncident.vue?vue&type=style&index=0&id=8a3986dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a3986dc"]])

export default __exports__